import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-x",
  "use": "icon-icon-x-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-x\">\n<path d=\"M16.2656 10.75L28.5986 29.25H23.7344L11.4014 10.75H16.2656Z\" stroke=\"white\" stroke-width=\"1.5\" />\n<path d=\"M18.9365 22.4453L12.2227 30H10L18.0674 20.9229L18.9365 22.4453ZM30 10L21.9082 19.1016L21.0537 17.5635L27.7773 10H30Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol